import React, { useEffect, useState, useRef } from 'react';
import { Dropdown, Input, Empty } from 'antd';
import adsStyle from '@wkd/ads-style';
import classNames from 'classnames';
import IconFont from '../IconFont';
import './index.scss';

const BASE_CLS = 'ads-account-select';
const getUtcString = (zone) => `UTC${zone >= 0 ? '+' : '-'}${Math.abs(zone)}`;
const AccoutSelect = ({ primaryAccountName, value, onChange, options }) => {
  const [_options, setOptions] = useState(options);
  const menuRef = useRef();
  const [menuVisible, setMenuVisible] = useState(false);
  const [search, setSearch] = useState('');
  const curLabel = `${primaryAccountName} / ${options?.find((item) => item.value === value)?.label}`;

  useEffect(() => {
    setOptions(options);
  }, [options]);

  useEffect(() => {
    if (search) {
      setOptions(
        options.filter((item) => item.label.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1),
      );
    } else {
      setOptions(options);
    }
  }, [search]);
  useEffect(() => {
    function mouseClickHandler(e) {
      if (menuRef.current) {
        if (!menuRef.current?.contains(e.target)) {
          setMenuVisible(false);
          setSearch('');
        }
      }
    }

    document.addEventListener('mousedown', mouseClickHandler);

    return () => {
      document.removeEventListener('mousedown', mouseClickHandler);
    };
  }, []);

  function handleClick() {
    setMenuVisible(true);
  }

  function handleSearchChange(e) {
    setSearch(e.target.value);
  }

  function handleOptionClick(v) {
    onChange(v);
    setSearch('');
    setMenuVisible(false);
  }

  return (
    <Dropdown
      destroyPopupOnHide
      align={{
        offset: [0, 5],
      }}
      placement="bottomLeft"
      overlay={
        <div ref={menuRef}>
          <div className={`${BASE_CLS}-search`}>
            <Input value={search} onChange={handleSearchChange} placeholder="Search" />
            <IconFont type="icon-search" style={{ fontSize: 16, color: adsStyle['$A8'] }} />
          </div>
          <div className={`${BASE_CLS}-content`}>
            <div className={`${BASE_CLS}-title hide-text`}>{`Account manager: ${primaryAccountName}`}</div>
            {_options.map((item) => (
              <div
                onClick={() => handleOptionClick(item.value)}
                key={item.value}
                className={classNames(`${BASE_CLS}-item  df aic cp jcsb`, { active: value === item.value })}
              >
                <span className="hide-text mr8">{item.label}</span>
                <span>{getUtcString(item.zone)}</span>
              </div>
            ))}
            {_options.length ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
          </div>
        </div>
      }
      overlayClassName={`${BASE_CLS}-menu`}
      visible={menuVisible}
    >
      <div
        style={{ display: 'flex', gap: 8 }}
        className={classNames(BASE_CLS, 'pt8 cp pb8 br8 pl10 pr10 df aic', {
          active: menuVisible,
        })}
        onClick={handleClick}
      >
        <IconFont style={{ fontSize: 18, color: adsStyle['$A1'] }} type="icon-account-new1" />
        <div className="hide-text f1">{curLabel}</div>
        <IconFont style={{ fontSize: 14, color: adsStyle['$A1'] }} type="icon-triangle" />
      </div>
    </Dropdown>
  );
};

export default AccoutSelect;
